<template>
  <div class="ai-chat-container">
    <!-- 悬浮按钮 -->
    <button
      class="floating-btn"
      :class="{ expanded: isExpanded }"
      @click="toggleChat"
    >
      <!-- <el-icon size="20">
        <ChatLineRound />
      </el-icon> -->
      <el-tooltip
        effect="dark"
        content="AI助手"
        placement="top"
        v-if="!isExpanded"
      >
        <img
          src="../../assets/image/logo_white.png"
          alt="AI助手"
          class="imgLogo"
        />
      </el-tooltip>

      <!-- <i class="el-icon-chat-line-round"></i> -->
      <i class="el-icon-close" v-else></i>
      <!-- <el-icon size="24">
        <CloseBold />
      </el-icon> -->
    </button>

    <!-- 聊天窗口 -->
    <div v-if="isExpanded" class="chat-window">
      <div class="chat-header">
        <h3>AI 助手</h3>
        <div class="header-actions">
          <el-button type="text" @click="clearMessages" icon="el-icon-delete">
            清空
          </el-button>
        </div>
      </div>

      <div class="chat-messages" ref="messagesContainerRef">
        <div
          v-for="(msg, index) in messages"
          :key="index"
          :class="['message', msg.role]"
        >
          <div class="avatar">
            <div class="avatar-user VerticalMid" v-if="msg.role === 'user'">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#fax-user"></use>
              </svg>
            </div>
            <div class="avatar-ai VerticalMid" v-else>
              <img
                src="../../assets/image/logo_white.png"
                alt="AI助手"
                class="imgAvatar"
              />
            </div>
          </div>
          <div class="content">
            <div class="message-text">{{ msg.content }}</div>
            <div class="timestamp">{{ formatTime(msg.timestamp) }}</div>
            <template v-if="!regNullArray(messages) && messages.length == 1">
              <div class="example-box">查看李小红基础信息</div>
              <div class="example-box">因食堂就餐插队，给李小红扣0.5分</div>
              <div class="example-box">打开李小红的成长档案</div>
            </template>
          </div>
        </div>

        <!-- 显示加载状态 -->
        <div v-if="isLoading" class="message assistant">
          <div class="avatar">
            <div class="avatar-ai VerticalMid">
              <img
                src="../../assets/image/logo_white.png"
                alt="AI助手"
                class="imgAvatar"
              />
            </div>
          </div>
          <div class="content">
            <div class="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>

      <div class="chat-input-area">
        <el-input
          v-model="inputMessage"
          placeholder="输入消息..."
          :rows="2"
          type="textarea"
          resize="none"
          maxlength="500"
          show-word-limit
          @keyup.enter.native="handleSend"
        />
        <el-button
          type="primary"
          :disabled="!inputMessage || isLoading"
          @click="handleSend"
          class="send-btn"
        >
          发送
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as dd from "dingtalk-jsapi";
export default {
  props: {},
  data() {
    return {
      isExpanded: false,
      inputMessage: null,
      messages: [],
      //{
      //   id: null,
      //   content: null,
      //   role: null, // 'user' | 'assistant'
      //   timestamp: null,
      // }
      // userMessage:{
      //   content:null,
      //   role:'user',
      //   timestamp: new Date()
      // },
      // aiResponse:{
      //   content: null,
      //   role: 'assistant',
      //   timestamp: new Date()
      // },
      isLoading: false,
      // messagesContainerRef: {
      //   scrollTop: 0,
      //   scrollHeight: 0,
      // },
      optActions: [],
    };
  },
  created() {
    let that = this;
    // let temp =
    //   '{studentId:"b56503bf-3fe9-43b8-8c74-07fcc5b4e3d9",reasonId:"27bc9889-ad4e-47cf-af61-0646cce4423f",score:-1}';
    // console.log(JSON.parse(temp));
    that.optActions = JSON.parse(that.$GetKey("actions"));
    // 初始化欢迎消息
    that.messages.push({
      content: "你好！我是AI助手，有什么可以帮助你的吗？",
      role: "assistant",
      timestamp: new Date(),
    });
  },
  methods: {
    async getChatAI(objData) {
      let that = this;
    },
    /**
     * 清空消息
     */
    clearMessages() {
      let that = this;
      that.messages = [];
      that.messages.push({
        content: "你好！我是AI助手，有什么可以帮助你的吗？",
        role: "assistant",
        timestamp: new Date(),
      });
    },
    formatTime(date) {
      let that = this;
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    // 切换聊天窗口显示/隐藏
    toggleChat() {
      let that = this;
      that.isExpanded = !that.isExpanded;
      if (that.isExpanded && that.messages.length === 0) {
        // 初始化欢迎消息
        that.messages.push({
          content: "你好！我是AI助手，有什么可以帮助你的吗？",
          role: "assistant",
          timestamp: new Date(),
        });
      }
    },
    // 发送消息
    async handleSend() {
      let that = this;
      if (!that.inputMessage || that.isLoading) return;

      // 添加用户消息
      const userMessage = {
        content: that.inputMessage,
        role: "user",
        timestamp: new Date(),
      };
      that.messages.push(userMessage);

      // 清空输入框
      that.inputMessage = "";

      // 滚动到底部
      // await that.$nextTick();
      // that.scrollToBottom();
      that.$nextTick(() => {
        that.scrollToBottom();
      });

      // 设置加载状态
      that.isLoading = true;

      try {
        // 调用实际AI API
        ajaxChatAI(
          that,
          "/api/ai/chat",
          {
            query: userMessage.content,
          },
          (response) => {
            if (regNull(response)) {
              that.isLoading = false;
              // 添加错误消息
              const errorMessage = "抱歉，发生了一些错误，请稍后再试。";
              that.messages.push({
                content: errorMessage,
                role: "assistant",
                timestamp: new Date(),
              });
              return false;
            }

            // 处理API响应，根据实际返回的数据结构调整
            if (
              !regNull(response.command) &&
              response.command !== "redirectUrl"
            ) {
              const aiResponse = {
                content: response.message,
                role: "assistant",
                timestamp: new Date(),
              };
              that.messages.push(aiResponse);
            }

            that.isLoading = false;

            // 滚动到底部
            that.$nextTick(() => {
              that.scrollToBottom();
            });

            if (response.success && !regNull(response.command)) {
              // 设置加载状态
              that.isLoading = true;
              switch (response.command) {
                case "logoff": // 注销
                  setTimeout(() => {
                    that.onLogout();
                  }, 3000);
                  break;
                case "redirectUrl": // 跳转页面
                  if (!regNull(response.arg)) {
                    that.onRedirectUrl(response);
                  } else {
                    throw new Error("抱歉，没有找到相关页面。"); // 抛出异常中断
                  }
                  break;
                case "profile": // 学生详情
                  that.isLoading = false;
                  if (!regNull(response.arg)) {
                    that.onProfile(response.arg);
                  } else {
                    throw new Error("未能找到学生"); // 抛出异常中断
                  }
                  break;
                case "daily": // 行为扣分（个人）
                  if (!regNull(response.arg)) {
                    that.isLoading = false;
                    that.onDaily(JSON.parse(response.arg));
                  } else {
                    throw new Error("抱歉，发生了一些错误，请稍后再试。"); // 抛出异常中断
                  }
                  break;
                case "dailyClass": // 行为扣分（班级）
                  if (!regNull(response.arg)) {
                    that.isLoading = false;
                    that.onDailyClass(JSON.parse(response.arg));
                  } else {
                    throw new Error("抱歉，发生了一些错误，请稍后再试。"); // 抛出异常中断
                  }
                  break;
                case "growlog":
                  that.isLoading = false;
                  if (!regNull(response.arg)) {
                    that.onGrowlog(response.arg);
                  } else {
                    throw new Error("未能找到学生"); // 抛出异常中断
                  }
                default:
                  that.isLoading = false;
                  break;
              }

              /*if (response.code === "logoff()") {
                that.onLogout();
              } else {
                eval(response.code);
              }*/
            } else {
              const aiResponse = {
                content: response.message,
                role: "assistant",
                timestamp: new Date(),
              };
              that.messages.push(aiResponse);
            }
          }
        );
      } catch (error) {
        console.error("发送消息失败:", error);
        that.isLoading = false;

        // 添加错误消息
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "抱歉，发生了一些错误，请稍后再试。";

        that.messages.push({
          content: errorMessage,
          role: "assistant",
          timestamp: new Date(),
        });
      }
    },
    /**
     * 日常扣分（班级）
     * @param objARG
     */
    onDailyClass(objARG) {
      let that = this;
      // school_record
      // /Admin/Adviser/Morality/Record

      if (!regNullArray(that.optActions)) {
        for (const item of that.optActions) {
          if (
            item.code.toLowerCase() === "school_record" &&
            item.url.toLowerCase() === "/admin/adviser/morality/record"
          ) {
            that.$emit("success", [item.actionId, item.url]);
            break;
          }
        }
      }

      setTimeout(() => {
        that.$router.push({
          path: "/Admin/Adviser/Morality/Create/1",
          query: {
            url: that.$router.history.current.fullPath,
            content: objARG,
          },
        });
      }, 300);
    },
    /*
     * 日常扣分（个人）
     */
    onDaily(objARG) {
      let that = this;
      // school_record
      // /Admin/Adviser/Morality/Record

      if (!regNullArray(that.optActions)) {
        for (const item of that.optActions) {
          if (
            item.code.toLowerCase() === "school_record" &&
            item.url.toLowerCase() === "/admin/adviser/morality/record"
          ) {
            that.$emit("success", [item.actionId, item.url]);
            break;
          }
        }
      }
      setTimeout(() => {
        that.$router.push({
          path: "/Admin/Adviser/Morality/Create/3",
          query: {
            url: that.$router.history.current.fullPath,
            content: objARG,
          },
        });
      }, 300);
    },
    /**
     * 学生详情
     * @param objArg
     */
    onProfile(objArg) {
      let that = this;
      // students_index
      // /Admin/Student/Index
      let tempIndex = null;
      if (!regNullArray(that.optActions)) {
        for (const item of that.optActions) {
          if (
            item.code.toLowerCase() === "students_index" &&
            item.url.toLowerCase() === "/admin/student/index"
          ) {
            console.log("--->", [item.actionId, item.url]);
            // tempIndex = [item.actionId, item.url];
            that.$emit("success", [item.actionId, item.url]);

            break;
          }
        }
      }

      setTimeout(() => {
        that.$router.push({
          path: "/Admin/Student/Detail/" + objArg,
          query: {
            url: that.$router.history.current.fullPath,
          },
        });
      }, 300);
    },
    /**
     * 成长档案
     * @param objArg
     */
    onGrowlog(objArg) {
      let that = this;
      // growtharchives_index
      // /Admin/GrowthArchives/Index
      let tempIndex = null;
      if (!regNullArray(that.optActions)) {
        for (const item of that.optActions) {
          if (
            item.code.toLowerCase() === "growtharchives_index" &&
            item.url.toLowerCase() === "/admin/growtharchives/index"
          ) {
            that.$emit("success", [item.actionId, item.url]);
            break;
          }
        }
      }

      setTimeout(() => {
        that.$router.push({
          path: "/Admin/GrowthArchives/Details/" + objArg,
          query: {
            url: that.$router.history.current.fullPath,
          },
        });
      }, 300);
    },
    /**
     * 页面跳转
     */
    onRedirectUrl(response) {
      let that = this;
      let objKey = response.arg;

      if (!regNullArray(that.optActions)) {
        let tempIndex = 0;
        for (const item of that.optActions) {
          if (
            item.isMenu === true &&
            regNull(item.url) === false &&
            item.name.includes(objKey)
          ) {
            that.isLoading = false;
            tempIndex = -1;

            const aiResponse = {
              content: response.message,
              role: "assistant",
              timestamp: new Date(),
            };
            that.messages.push(aiResponse);

            that.$emit("success", [item.actionId, item.url]);

            that.$router.push({
              path: item.url,
              query: {
                url: that.$router.history.current.fullPath,
              },
            });
            break;
          } else {
            tempIndex++;
          }
        }
        setTimeout(() => {
          that.isLoading = false;
          if (tempIndex > 0) {
            that.messages.push({
              content: "抱歉，没有找到相关页面。",
              role: "assistant",
              timestamp: new Date(),
            });
          }
        }, 300);
      } else {
        that.isLoading = false;
        that.messages.push({
          content: "抱歉，没有找到相关页面。",
          role: "assistant",
          timestamp: new Date(),
        });
      }
    },
    /**
     * 注销
     */
    onLogout() {
      let that = this;
      that.$RemoveKey();
      if (dd.env.platform !== "notInDingTalk") {
        this.$router.push("/Logout");
      } else {
        this.$router.push("/Login");
      }
    },
    // 滚动到底部
    scrollToBottom() {
      let that = this;
      const container = that.$refs.messagesContainerRef;
      if (container) {
        // 设置scrollTop为scrollHeight，即滚动到底部
        container.scrollTop = container.scrollHeight;
      }
    },
  },
  watch: {
    isExpanded(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.ai-chat-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}

.floating-btn {
  width: 60px;
  font-size: 22px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #11559c, #6e7cff);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(102, 102, 255, 0.4);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  animation: float 3s ease-in-out infinite;
  z-index: 10000;

  .imgLogo {
    width: 40px;
  }
}

.floating-btn:hover {
  transform: scale(1.1) translateY(-3px);
  box-shadow: 0 8px 25px rgba(102, 102, 255, 0.5);
}

.floating-btn:active {
  transform: scale(0.95);
}

.floating-btn.expanded {
  position: absolute;
  bottom: calc(100% + 10px); /* 放置在聊天窗口上方 */
  right: 0;
  animation: none;
  transform: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-6px);
  }
  100% {
    transform: translateY(0px);
  }
}

.chat-window {
  width: 520px;
  height: 500px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: absolute;
  bottom: 80px; /* 确保不与悬浮按钮重叠 */
  right: 0;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.chat-header {
  padding: 16px;
  background: linear-gradient(to right, #e7eef5, #f0f9ff);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.chat-header h3 {
  margin: 0;
  font-size: 16px;
  color: #11559c;
  font-weight: 600;
}

.header-actions .el-button {
  padding: 6px 12px;
  font-size: 14px;
}

.chat-messages {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #fafbff;
}

.message {
  display: flex;
  gap: 12px;
  max-width: 85%;
}

.message.user {
  align-self: flex-end;
  flex-direction: row-reverse;
}

.avatar {
  flex-shrink: 0;

  .avatar-ai {
    background: linear-gradient(135deg, #11559c, #6e7cff);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    .imgAvatar {
      width: 25px;
    }
  }
  .avatar-user {
    background: #ebf5ff;
    color: #419fff;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}

.content {
  display: flex;
  flex-direction: column;
}

.example-box {
  background-color: white;
  border: 1px solid #eee;
  border-radius: 8px;
  font-size: 12px;
  padding: 4px 8px;
  color: #909199;
  font-style: italic;
  margin: 2px 0;
}

.message-text {
  padding: 14px 18px;
  border-radius: 18px;
  line-height: 1.5;
  word-wrap: break-word;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  font-size: 14px;
}

.message.user .message-text {
  background: linear-gradient(to right, #11559c, #6e7cff);
  color: white;
  // border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}

.message.assistant .message-text {
  background-color: white;
  color: var(--el-text-color-primary);
  // border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  border: 1px solid #eee;
}

.timestamp {
  font-size: 11px;
  color: #999;
  margin-top: 6px;
  text-align: right;
}

.typing-indicator {
  display: flex;
  gap: 4px;
  padding: 12px 16px;
  background-color: white;
  border-radius: 18px;
  border-top-left-radius: 4px;
  border: 1px solid #eee;
}

.typing-indicator span {
  width: 8px;
  height: 8px;
  background-color: #11559c;
  border-radius: 50%;
  display: inline-block;
  animation: typing 1.4s infinite ease-in-out;
}

.typing-indicator span:nth-child(1) {
  animation-delay: -0.32s;
}

.typing-indicator span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes typing {
  0%,
  80%,
  100% {
    transform: scale(0.7);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.chat-input-area {
  padding: 16px;
  background: white;
  border-top: 1px solid #eee;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.chat-input-area .el-textarea {
  flex: 1;
}

.send-btn {
  align-self: flex-end;
  min-width: 60px;
  border-radius: 8px;
  font-weight: 500;
}
</style>
